import {ActionReducer, MetaReducer} from "@ngrx/store";
import {HomeReducer} from "./home/home.reducer";
import {
  DeliveryAgent,
  DeliveryDetails,
  IETADetails,
  IFeatureVisbilityProperties,
  IOrderStatus,
  IRatingDetails,
  Location,
  OrderDeliveryDetails,
  OrderDocument,
  OrderInfoDetails,
  TimelineEvent
} from "../models/DeliveryDetails";
import {LatLng} from "leaflet";
import {StatusData, TrackData} from "src/app/models/custom.types";
import { IOrderConfig, OrdersById } from "../components/calibrate-data/calibrate-data.component";

type Reducers = { home: ActionReducer<HomeState> }


export interface AppState {
  home: HomeState
}

export interface HomeState {
  deliveryTokenId: string,
  status: string,
  deliveryDetails?: DeliveryDetails
  pickUpLatLng?: LatLng
  agentLatLng?: LatLng
  deliveryLatLng?: LatLng
  agentImage?: string
  accountImage?: string,
  orderTimeLineDetails: TimelineEvent[]
  orderDetails?: OrderInfoDetails
  deliveryAgentDetails?: DeliveryAgent,
  polyline?: LatLng[],
  deliveryDateTimeDetails?: OrderDeliveryDetails,
  deliveryLocationDetails?: Location,
  ratingDetails?: IRatingDetails[],
  trackData?: TrackData,
  statusData?: StatusData
  successAnimationMsg?: string,
  etaDetails?: IETADetails,
  orderStatus?: IOrderStatus,
  deliveryAcknowledgeViewStatus:boolean,
  featureVisbilityProperties:IFeatureVisbilityProperties | undefined,
  warehouseOrderId:string
  isParamOrderId:string,
  orderIdForTimeline:string,
  docketId:string,
  orderStatusForTimeline: string,
  orderDetailsData?:OrdersById,
  orderDataInfoConfig?:IOrderConfig
  orderDocuments:Array<OrderDocument>
  pickUpLocationDetails?: { name: string; address: string }
  loading: boolean
  apiError: boolean
}

export const reducers: Reducers = {home: HomeReducer};

export function debug(reducer: ActionReducer<any>): ActionReducer<any> {
  return function (state, action) {
    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<AppState>[] = [debug];
